import { GetCBUListProps } from "@/services/cbu.service";

export interface CBUFRProps {
  search?: string;
  account_type?: number[];
}

export const getCBUFilterRequest = (
  event: CBUFRProps,
): Partial<GetCBUListProps> => {
  return {
    ...(event?.search
      ? {
          busqueda: event?.search,
        }
      : {}),
    ...(event?.account_type?.length
      ? {
          tipoCuenta: event?.account_type?.[0],
        }
      : {}),
  };
};
